<template lang="pug">
include /mixins

+b.education-form
  +e.content
    validation-provider(
      v-slot="{ errors, validate }"
      :name='name'
      :bails='false'
      :ref='`${name}_valid`'
      :rules='rules'
    )
      div.relative
        input(
          type='hidden',
          :vid='name'
          :name='name'
          :ref='name'
          v-model='selectedValue'
        )
        +b.error-label--top.LABEL(v-if="errors.length") {{ errors[0] }}
        v-selection-controller(
          :options='variants'
          :multiple='false',
          :key-getter="$options.keyGetter",
          v-model='selectedValue'
          v-slot="{ options, value: model, change }"
        )
          +b.g-row--appearance_spaced
            +b.g-cell.g-cols(v-for='{ value } in options')
              +b.tt-space_mt--3.tt-space_ml--3
                +b.d-control-static-input--appearance_inline.TAG(
                  :rules='{ required: { allowFalse: true } }',
                  :tag='"input"'
                  :input-label='value.label'
                  :key='`key_${name}${value.value}`'
                  v-model='model'
                  :checked.props='model[0] && model[0].value == value.value'
                  :id='`level_${name}_${value.value}`'
                  :ref='`level_${name}_${value.value}`'
                  @change='change(value); setValue(value)'
                  type='radio'
                  :name='`${name}name`'
                )
                label.input-group__input(
                  :for='`level_${name}_${value.value}`'
                ) {{ value.label }}

</template>

<script>
import {
  createDocument,
  deleteDocument,
} from '@api/ticket_management.service'

import TicketManagementGallery from '@app/TicketManagement/Gallery'

import FileLoader from '@app/TicketManagement/FileLoader'

export default {
  name: 'Education',
  keyGetter: x => `${x.value}`,
  props: {
    name: {
      default: 'medical_education_level',
    },
    forcePush: {
      type: Boolean,
      default: true,
    },
    value: {
      type: Object,
      default: () => null,
    },
    rules: {
      type: Object,
      default: () => ({ required: false }),
    },
  },
  createDocument,
  deleteDocument,
  components: {
    FileLoader,
    TicketManagementGallery,
  },
  data() {
    return {
      variants: [
        {
          value: true,
          label: this._('Да'),
          required: true,
        },
        {
          value: false,
          label: this._('Нет'),
          required: true,
        },
      ],
      selectedValue: null,
    }
  },
  watch: {
    value: {
      handler(nval, oval) {
        this.selectedValue = nval
      },
      immediate: true,
    },
  },
  created() {
    if (this.forcePush) this.$emit('input', this.variants[0])
  },
  methods: {
    setValue(value) {
      this.selectedValue = value
      this.$emit('input', value)
    },
  },
}
</script>
